import { BP_CAPACITE, BP_CONCLUSION, BP_CONTROLES, BP_DIX_ANS, BP_TRAJECTOIRE } from "./content2";
import { CardList, DataTable } from "./blocks";

const Bilan = () => (
  <div className="border-4 border-mm-ink p-6 md:p-10">
    <p className="mm-lab text-mm-golddark">Bilan prévisionnel mécanique · avant économies ou recettes nouvelles</p>
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6 tab">
      <div><p className="text-sm">Entrées de référence</p><p className="disp text-3xl">1 561,6 Md€</p></div>
      <div><p className="text-sm">Sorties : 1 714,1 + 150</p><p className="disp text-3xl">1 864,1 Md€</p></div>
      <div><p className="text-sm">Écart</p><p className="disp text-3xl text-mm-red">−302,5 Md€/an</p></div>
      <div><p className="text-sm">Cumul mécanique 10 ans</p><p className="disp text-3xl text-mm-red">−3 025 Md€</p></div>
    </div>
    <p className="mm-body mt-6">Un plan de restructuration n'est pas une intention. <strong>C'est une capacité démontrée.</strong> « Pouvons-nous démontrer, année après année, comment nous le financerons et comment nous tiendrons le plan ? »</p>
  </div>
);

const DixAns = () => (
  <div>
    <h3 className="disp text-3xl md:text-4xl">Dix ans pour une sortie honorable</h3>
    <p className="mm-body mt-3 mb-8">Pas dix ans pour subir. Dix ans pour restructurer, investir, mesurer, corriger et retrouver une capacité à choisir.</p>
    <ol className="st grid md:grid-cols-4 gap-6">
      {BP_DIX_ANS.map((s, i) => (
        <li key={s.t} className="border-t-4 border-mm-red pt-4" data-testid={`bp-etape-${i + 1}`}>
          <p className="disp text-4xl text-mm-red">{i + 1}</p>
          <p className="disp text-xl mt-2">{s.t}</p>
          <p className="text-sm mt-2">{s.d}</p>
        </li>
      ))}
    </ol>
    <p className="mm-body mt-8 font-bold">Sortie honorable : une règle claire + un effort partagé + des investissements productifs + un contrôle permanent + une date de sortie.</p>
  </div>
);

export const BusinessPlanSuite = () => (
  <>
    <Bilan />
    <div>
      <h3 className="disp text-3xl md:text-4xl mb-8">Capacité à fournir et respecter le plan</h3>
      <CardList items={BP_CAPACITE} cols="md:grid-cols-2 lg:grid-cols-3" />
    </div>
    <div>
      <h3 className="disp text-3xl md:text-4xl mb-2">Exemple de trajectoire de retour à l'équilibre</h3>
      <p className="text-sm mb-6">Illustration de méthode — pas une prévision (Md€/an).</p>
      <DataTable testid="bp-trajectoire-table" head={["Année", "Écart avant mesures", "Mesures cumulées", "Écart résiduel", "Objectif"]} rows={BP_TRAJECTOIRE} />
    </div>
    <div className="bg-mm-alt p-6 md:p-10">
      <p className="mm-lab text-mm-golddark">Le contrat · faire accepter la restructuration</p>
      <p className="disp text-2xl md:text-3xl mt-4 leading-tight">Je fais un effort aujourd'hui. Vous me montrez où il va. Vous mesurez le résultat. Vous appliquez la même règle à tous. Vous corrigez ce qui ne fonctionne pas. Vous donnez une date de sortie.</p>
      <p className="mm-body mt-6 text-mm-red font-bold">La Grande Question : comment demander un effort sans donner un espoir ?</p>
    </div>
    <div>
      <h3 className="disp text-3xl md:text-4xl mb-2">Qui fixe la règle ? Qui contrôle celui qui la fixe ?</h3>
      <p className="mm-body mb-6">De la famille à l'entreprise, puis à l'État : responsabilité, contrôle, sanction.</p>
      <CardList items={BP_CONTROLES.map(([t, d]) => ({ t, d }))} cols="md:grid-cols-2 lg:grid-cols-3" />
    </div>
    <DixAns />
    <div className="border-t-4 border-mm-ink pt-8">
      <h3 className="disp text-3xl md:text-4xl">Conclusion : la Grande Question, encore et encore</h3>
      <p className="mm-body mt-3">Un budget familial, un budget d'entreprise, un budget national : les règles de base restent les mêmes.</p>
      <ul className="mt-6 grid md:grid-cols-2 gap-x-8">
        {BP_CONCLUSION.map((q) => <li key={q} className="disp text-xl border-b border-mm-ink/20 py-3">{q}</li>)}
      </ul>
      <p className="disp text-3xl text-mm-red mt-8">La réponse est dans la question.</p>
    </div>
  </>
);
